export const productCatalogue = {
  pageView: (productName) => ({
    event_name: 'page_view, journey_start',
    page_name: 'vodapay: business advance: opf: funding options',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    event_category: productName
  }),

  nextClick: (productName) => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: funding options',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_name: 'vodapay: business advance: opf: funding options: next',
    event_category: productName
  }),

  backClick: (productName) => ({
    event_name: 'ui_interaction',
    page_name: 'vodapay: business advance: opf: funding options',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    link_name: 'vodapay: business advance: opf: funding options: back',
    event_category: productName
  })
};
